import { render, staticRenderFns } from "./MIcon.vue?vue&type=template&id=285dbe12&scoped=true"
import script from "./MIcon.vue?vue&type=script&lang=js"
export * from "./MIcon.vue?vue&type=script&lang=js"
import style0 from "./MIcon.vue?vue&type=style&index=0&id=285dbe12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285dbe12",
  null
  
)

export default component.exports